module.exports = __webpack_public_path__ + "media/components/Sponsors/Shared/Icons/loading-d8855914a8a9c77c3fea9f169c43e92d.gif";